<template>
  <DialogLayout class="pe-site-plan-log">
    <template #header>
      <div class="title">【{{rowData.name}}】- 培养方案调整记录</div>
    </template>
    <div class="log-main"
         v-loading="loading"
         element-loading-text="数据加载中，请稍等...">
      <template v-if="changeLogs">
        <template v-if="changeLogs.length">
          <AppScrollbar style="height: 100%">
            <div class="log-cont">
              <el-timeline>
                <el-timeline-item v-for="changeLog in changeLogs"
                                  :key="changeLog.id">
                  <div class="log-item">
                    <div class="header">
                      <span v-if="changeLog.planName"
                            class="plan">{{changeLog.planName}}年起</span>
                      <el-tag size="mini"
                              :type="changeLog.op | opType">{{changeLog.opNote}}</el-tag>
                    </div>
                    <div v-if="changeLog.details && changeLog.details.length"
                         class="body">
                      <div v-for="detail in changeLog.details"
                           :key="detail.id"
                           class="detail">
                        <div class="info-box">
                          <div class="label">课程类别：</div>
                          <div class="value">{{detail.courseType}}</div>
                        </div>
                        <div class="info-box">
                          <div class="label">程程名称：</div>
                          <div class="value">{{detail.courseName}}</div>
                        </div>
                        <div class="info-box">
                          <div class="label">课程代码：</div>
                          <div class="value">{{detail.courseCode}}</div>
                        </div>
                        <div class="info-box">
                          <div class="label">学时：</div>
                          <div class="value">{{detail.creditHour}}</div>
                        </div>
                        <div class="info-box">
                          <div class="label">学分：</div>
                          <div class="value">{{detail.credit}}</div>
                        </div>
                        <div class="info-box">
                          <div class="label">考核方式</div>
                          <div class="value">{{detail.examStyle}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="footer">
                      <span v-if="changeLog.operator"
                            class="operator">操作人：{{changeLog.operator}}</span>
                      <span v-if="changeLog.opDate"
                            class="op-date">{{changeLog.opDate}}</span>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </AppScrollbar>
        </template>
        <template v-else>
          <Hint type="empty">
            <div>没有调整记录</div>
          </Hint>
        </template>
      </template>
      <template v-else>
        <Hint v-if="!loading"
              type="error">
          <div>调整记录加载失败</div>
          <el-button type="text"
                     @click="loadChangeLogs">重新加载</el-button>
        </Hint>
      </template>
    </div>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'PeSitePlanLog',
  components: {
    DialogLayout,
    AppScrollbar,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      changeLogs: null
    }
  },
  filters: {
    opType (val) {
      if (val === '1') {
        return 'success'
      } else if (val === '0') {
        return 'danger'
      } else {
        return 'warning'
      }
    }
  },
  methods: {
    loadChangeLogs () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/basic/peSite/plan/changeLogs',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.changeLogs = response.data['changeLogs'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadChangeLogs()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadChangeLogs()
      }
    }
  }
}
</script>

<style lang="scss">
  .pe-site-plan-log {
    width: 500px;
    max-width: 100%;
    height: 100%;
    .log-main {
      height: 100%;
      .log-cont {
        padding: 15px 20px;
        .el-timeline {
          margin: 0;
          padding: 0;
          .el-timeline-item {
            &:last-child {
              padding-bottom: 0;
            }
            .log-item {
              & > .header {
                & > .plan {
                  margin-right: 5px;
                  font-size: 12px;
                  font-weight: bold;
                }
              }
              & > .body {
                margin-top: 10px;
                .detail {
                  padding: 10px 15px;
                  background-color: #fff;
                  border-radius: 4px;
                  box-shadow: 0 0 6px rgba(0,0,0,.1);
                  .info-box {
                    display: flex;
                    font-size: 12px;
                    & > .label {
                      flex: none;
                      width: 64px;
                      color: #606266;
                    }
                    & > .value {
                      color: #303133;
                      &:empty {
                        &:before {
                          content: '\002d\002d';
                          color: #909399;
                        }
                      }
                    }
                    & + .info-box {
                      margin-top: 5px;
                    }
                  }
                  & + .detail {
                    margin-top: 12px;
                  }
                }
              }
              & > .footer {
                margin-top: 5px;
                & > .operator {
                  margin-right: 10px;
                  color: #909399;
                  font-size: 12px;
                }
                & > .op-date {
                  font-size: 12px;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
